import { heroContent } from "./servicesContent";

export const SERVICES_SEO = {
  title:
    "ISO Certification, Compliance & Sustainability Consulting Services | MBA Solutions",
  description:
    "Explore MBA Solutions services including ISO certification consultancy, food safety compliance, sustainability consulting, ESG solutions, textile standards and supply chain certifications.",
  keywords:
    "ISO certification consultancy, compliance services, food safety compliance, sustainability consulting, ESG solutions, textile standards, supply chain certification, MBA Solutions",
  canonical: "https://mbasolutions.co/services",
  ogImage: "https://mbasolutions.co/assets/Logo.webp",
  h1: heroContent.h1,
};

export const buildServicesJsonLd = () => [
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "Home",
        item: "https://mbasolutions.co/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "Services",
        item: SERVICES_SEO.canonical,
      },
    ],
  },
];

export default SERVICES_SEO;
